import { render, staticRenderFns } from "./ValueSetCard.vue?vue&type=template&id=17ed1682&scoped=true&"
import script from "./ValueSetCard.vue?vue&type=script&lang=js&"
export * from "./ValueSetCard.vue?vue&type=script&lang=js&"
import style0 from "./ValueSetCard.vue?vue&type=style&index=0&id=17ed1682&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ed1682",
  null
  
)

export default component.exports